// csrfService.js
const isDevelopment = process.env.REACT_APP_ENV === 'development';
const STRIPE_SERVER_URL = isDevelopment
    ? 'http://localhost:4000/node'
    : process.env.REACT_APP_STRIPE_SERVER_URL;

// csrfService.js with automatic token refresh
const csrfService = {
    token: null,
    tokenExpiry: null, // Store when the token expires

    // Add these debugging statements to csrfService.js

    // In getToken method
    async getToken(forceRefresh = false) {
        const now = Date.now();

        // Check if token is expired or about to expire
        const needsRefresh = forceRefresh ||
            !this.token ||
            !this.tokenExpiry ||
            now > (this.tokenExpiry - 5 * 60 * 1000);


        if (needsRefresh) {
            try {
                
                const response = await fetch(`${STRIPE_SERVER_URL}/api/csrf-token`, {
                    credentials: 'include'
                });


                if (!response.ok) throw new Error(`Failed to get CSRF token: ${response.status}`);

                const data = await response.json();
                

                this.token = data.csrfToken;
                this.tokenExpiry = now + (data.expiresIn || 7200000);

                
                return this.token;
            } catch (error) {
            
                throw error;
            }
        }

        return this.token;
    },

    // In fetch method
    async fetch(url, options = {}) {

        try {
            const token = await this.getToken();

            const headers = {
                ...options.headers,
                'X-CSRF-Token': token
            };

            const response = await fetch(url, {
                ...options,
                headers,
                credentials: 'include'
            });


            // If we get a 403, it might be due to an expired token
            if (response.status === 403) {

                try {
                    const newToken = await this.getToken(true);

                    const retryHeaders = {
                        ...options.headers,
                        'X-CSRF-Token': newToken
                    };

                    const retryResponse = await fetch(url, {
                        ...options,
                        headers: retryHeaders,
                        credentials: 'include'
                    });

                    return retryResponse;
                } catch (refreshError) {
                    throw new Error('Your session has expired. Please refresh the page and try again.');
                }
            }

            return response;
        } catch (error) {
            
            throw error;
        }
    },
};


export default csrfService;